import { SimulationReportGenerator } from './SimulationReportGenerator';

export const generateSimulationPDF = async (
  selectedRequest: any,
  userName: string,
  imageBase64: string,
  payouts?: any,
) => {
  const generator = new SimulationReportGenerator({
    userName,
    imageBase64,
    title: `Detalle ${selectedRequest.id ? `Solicitud ${selectedRequest.id}` : 'Simulación'}`,
    fileName: `${selectedRequest.id ? `Solicitud` : 'Simulación'}${selectedRequest.id ? `-${selectedRequest.id}` : ` ${selectedRequest.businessName}`}.pdf`,
    selectedRequest,
    payouts,
  });
  await generator.generate();
};
